import { timeDuration } from "@/lib/mapper";

export const lSize = 1200;
export const mlSize = 992;
export const mSize = 768;
export const smSize = 576;
export const sSize = 450;
export const ssSize = 320;

export const timeDurationDropdown = [
  {
    id: 1,
    value: timeDuration.MORNING,
    label: "ช่วงเช้า (08:00 - 12.00 น.)",
    type: "HALF_DAY"
  },
  {
    id: 2,
    value: timeDuration.AFTERNOON,
    label: "ช่วงบ่าย (13:00 - 17.00 น.)",
    type: "HALF_DAY"
  },
  {
    id: 3,
    value: timeDuration.FULL_DAY,
    label: "เต็มวัน (08:00 - 17.00 น.)",
    type: "FULL_DAY"
  },
	{
    id: 4,
    value: timeDuration.FULL_DAY_SPECIAL,
    label: "เต็มวัน (08:00 - 22.00 น.) *ห้องอย่างเดียว",
    type: "FULL_DAY"
  },
];

export const conferencePatternDropdown = [
  {
    id: 1,
    label: "Theatre",
    icon: "/static/icons/facility-icon/room-format/theater-format.svg",
  },
  {
    id: 2,
    label: "Classroom",
    icon: "/static/icons/facility-icon/room-format/classroom-format.svg",
  },
  {
    id: 3,
    label: "U-Shape",
    icon: "/static/icons/facility-icon/room-format/u-shape-format.svg",
  },
  {
    id: 4,
    label: "Workshop",
    icon: "/static/icons/facility-icon/room-format/workshop-format.svg",
  },
];

export const textTime = ' น.';
export const hyphenSymbol = '-';
